// extracted by mini-css-extract-plugin
export default {"img":"Rating_img__Zh53F","grey":"Rating_grey__9lJ3c"};